import dashboardRoutes from './dashboard.route';

export default [...dashboardRoutes];
